import localFont from 'next/font/local';

const mulishFont = localFont({
  src: [
    {
      path: './mulish-v12-latin-300.woff2',
      weight: '300',
      style: 'normal',
    },
    {
      path: './mulish-v12-latin-regular.woff2',
      weight: '400',
      style: 'normal',
    },
    {
      path: './mulish-v12-latin-600.woff2',
      weight: '600',
      style: 'normal',
    },
    {
      path: './mulish-v12-latin-700.woff2',
      weight: '700',
      style: 'bold',
    },
    {
      path: './Mulish-Black.ttf',
      weight: '900',
      style: 'bold',
    },
    {
      path: './Mulish-ExtraBold.ttf',
      weight: '800',
      style: 'bold',
    },
  ],
  display: 'swap',
  variable: '--font-mulish',
});

export default mulishFont;
